import { useMemo, useState } from 'react'
import * as ClientHttp from '../../../../../services/api/https/registration/client.http'
import { errorHandler } from '../../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  SWITCH_ASSOC: 'Alterando associação',
  INITIAL_CHECK: 'Adquirindo associacões',
}

const INITIAL_STATE = {
  associations: [],
  association: {
    client_id: 0,
    id: 0,
    actived: '',
    company_code: 0,
    company_id: 0,
  },
  customer: {},
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  globalFilter: '',
}

export default function useModalAssocEnterprise() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Actions
      switchCustomerAssociationWithTP(association) {
        ClientHttp.clientCompanyAssociatonHandler(
          association.client_id,
          association.company_id,
          association.company_code,
          association.id ? !association.actived : association.actived,
        )
          .then(associationsRes =>
            setState(prevState => ({
              ...prevState,
              associations: associationsRes,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      getCustomerCompaniesAssociaton(clientID) {
        if (clientID)
          ClientHttp.getClientCompaniesAssociaton(clientID)
            .then(associationsRes =>
              setState(prevState => ({
                ...prevState,
                associations: associationsRes,
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                errorMessage: errorHandler(err),
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
      },

      resetState() {
        setState(prevState => ({
          ...INITIAL_STATE,
          association: prevState.association,
          associations: prevState.associations,
          customer: prevState.customer,
        }))
      },

      onChange(field, value) {
        setState(prevState => ({ ...prevState, [field]: value }))
      },

      //Events
      onInit(customer) {
        setState(prevState => ({
          ...prevState,
          customer: customer,
          loadingMessage: LOAD_MESSAGE.INITIAL_CHECK,
        }))
      },

      onCheckBoxClicked(association) {
        if (association.company_code.length === 0)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Digite o código associado a este Cliente nesta Empresa',
          }))
        else
          setState(prevState => ({
            ...prevState,
            association: association,
            loadingMessage: LOAD_MESSAGE.SWITCH_ASSOC,
          }))
      },

      onCompanyClientCodeChange(association, value) {
        association.company_code = value.trim()
        setState(prevState => {
          const index = state.associations.findIndex(
            a => a.cliente_id && association.cliente_id && a.company_id === association.company_id,
          )
          if (index !== -1) prevState.associations[index] = association
          return { ...prevState }
        })
      },
    }
  }, [])

  return { state, localDispatch }
}
